import { TENANTS } from '@Config/Tenants';
import { PropsWithClassName } from '@Framework/ui';
import React, { PropsWithChildren } from 'react';

import logoAtDesktop from './assets/logo-AT-desktop.svg';
import logoAtMobile from './assets/logo-AT-mobile.svg';
import logoComDesktop from './assets/logo-COM-desktop.svg';
import logoComMobile from './assets/logo-COM-mobile.svg';
import logoFrDesktop from './assets/logo-FR-desktop.svg';
import logoFrMobile from './assets/logo-FR-mobile.svg';
import logoItDesktop from './assets/logo-IT-desktop.svg';
import logoItMobile from './assets/logo-IT-mobile.svg';
import logoTestDesktop from './assets/logo-TEST-desktop.svg';
import logoTestMobile from './assets/logo-TEST-mobile.svg';

interface Props extends PropsWithClassName {
  tenant: TENANTS;
  mobile: boolean;
  alt: string;
}

export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';

export const SHOP_LOGOS = {
  ['default']: {
    [MOBILE]: { src: logoComMobile, width: 110, height: 43 },
    [DESKTOP]: { src: logoComDesktop, width: 180, height: 70 }
  },
  [TENANTS.COM]: {
    [MOBILE]: { src: logoComMobile, width: 110, height: 43 },
    [DESKTOP]: { src: logoComDesktop, width: 180 - 180 * 0.4, height: 70 - 70 * 0.4 }
  },
  [TENANTS.AT]: {
    [MOBILE]: { src: logoAtMobile, width: 110, height: 43 },
    [DESKTOP]: { src: logoAtDesktop, width: 180, height: 70 }
  },
  [TENANTS.IT]: {
    [MOBILE]: { src: logoItMobile, width: 560, height: 228 },
    [DESKTOP]: { src: logoItDesktop, width: 172, height: 70 }
  },
  [TENANTS.FR]: {
    [MOBILE]: { src: logoFrMobile, width: 188, height: 70 },
    [DESKTOP]: { src: logoFrDesktop, width: 188, height: 70 }
  },
  [TENANTS.TEST]: {
    [MOBILE]: { src: logoTestMobile, width: 110, height: 43 },
    [DESKTOP]: { src: logoTestDesktop, width: 180, height: 70 }
  }
};
SHOP_LOGOS.default = SHOP_LOGOS[TENANTS.COM];

const ShopLogo: React.FC<Props> = (props: PropsWithChildren<Props>): React.ReactElement => {
  const { tenant, mobile, alt, ...imgAttrs } = props;
  const base = SHOP_LOGOS[tenant] ? SHOP_LOGOS[tenant] : SHOP_LOGOS.default;
  const logoImg = base[mobile ? MOBILE : DESKTOP];

  return (
    <img
      className={props.className}
      data-testid={'shop-logo-root'}
      alt={alt}
      src={logoImg.src}
      width={logoImg.width}
      height={logoImg.height}
      {...imgAttrs}
    />
  );
};

export { ShopLogo };
